
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  line-height:initial;
}

ul{
  list-style-type:none;
}

ul a{
    text-decoration:none;
    color:inherit;
  }

.dropdown{
  line-height:initial;
  z-index:3;
}

.icon__trigger{
  padding-left:1rem;
}

.dropdown__panel{
  left:0;
  top:0;
}

@media (min-width: 768px){

.dropdown__panel{
    position:absolute
}
  }

.se-main-nav--sub-link{
  display:flex;
  text-transform:uppercase;
  border-bottom:3px solid transparent;
  position:relative;
  width:-moz-fit-content;
  width:fit-content;
}

@media (min-width: 768px){

.se-main-nav--sub-link{
    text-transform:capitalize
}
  }

.button__trigger:hover{
  position:relative;
}

.button__trigger:hover::after{
    content:'';
    position:absolute;
    margin-top:0.25rem;
    display:flex;
    width:100%;
    height:4px;
    background-color:var(--brand-primary-1);
    top:100%;
    left:0;
  }

@media (max-width: 767px){

.se-main-nav--sub-menu li{
      padding-bottom:2rem
  }
    }

.se-main-nav--sub-menu li:hover > a::after{
      content:'';
      position:absolute;
      display:flex;
      width:100%;
      height:3px;
      background:var(--brand-primary-1);
      top:100%;
    }

.se-main-nav--sub-menu li > a:focus{
      outline:solid 2px var(--brand-primary-1) !important;
      border-radius:5px;
      width:-moz-fit-content;
      width:fit-content;
    }

@media (max-width: 767px){

.se-main-nav--sub-menu li:first-of-type{
      padding-top:2rem
  }
    }

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown']{
    display:flex;
    flex-direction:column;
    width:100%;
    z-index:4;
  }

@media (min-width: 768px){

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown']{
      margin:0;
      padding:2rem 3rem;
      overflow:hidden;
      position:relative;
      background-color:var(--brand-neutral-white);
      background-size:cover;
      background-position-x:200px;
      background-repeat:no-repeat;
      background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 624 366'%3E%3Cpath d='M1379.33 0H.0834656v366H1379.33V0Z' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M105.103 366c0-26.632 41.264-59.794 41.264-112.55 0-52.755-59.6595-81.901-59.6595-147.218 0-65.3158 29.8275-82.6176 29.8275-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M116.667 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.9965-81.901-59.9965-147.218 0-65.3158 30.0005-82.6176 30.0005-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M128.36 366c0-26.632 41.264-59.794 41.264-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.832-82.6176 29.832-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M139.586 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M151.383 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M162.852 366c0-26.632 41.489-59.794 41.489-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 30-82.6176 30-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M174.399 366c0-26.632 41.739-59.794 41.739-112.55 0-52.755-60.333-81.901-60.333-147.218 0-65.3158 30.157-82.6176 30.157-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M186.101 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.995-82.6176 29.995-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M197.665 366c0-26.632 41.73-59.794 41.73-112.55 0-52.755-60.333-81.901-60.333-147.218 0-65.3158 30.169-82.6176 30.169-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M209.358 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 30-82.6176 30-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M220.921 366c0-26.632 41.731-59.794 41.731-112.55 0-52.755-60.333-81.901-60.333-147.218 0-65.3158 30.166-82.6176 30.166-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M232.614 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M244.075 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.996-82.6176 29.996-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M255.872 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.996-82.6176 29.996-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M267.342 366c0-26.632 41.487-59.794 41.487-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 30.003-82.6176 30.003-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M278.78 366c0-26.632 41.509-59.794 41.509-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.991-82.6176 29.991-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M290.484 366c0-26.632 41.265-59.794 41.265-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.829-82.6176 29.829-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M302.048 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M313.738 366c0-26.632 41.268-59.794 41.268-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.827-82.6176 29.827-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M325.306 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.996-82.6176 29.996-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M337 366c0-26.632 41.263-59.794 41.263-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.832-82.6176 29.832-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M348.46 366c0-26.632 41.263-59.794 41.263-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.832-82.6176 29.832-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M360.022 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M371.495 366c0-26.632 41.485-59.794 41.485-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 30.003-82.6176 30.003-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M383.03 366c0-26.632 41.747-59.794 41.747-112.55 0-52.755-60.333-81.901-60.333-147.218 0-65.3158 30.155-82.6176 30.155-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M394.741 366c0-26.632 41.496-59.794 41.496-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.996-82.6176 29.996-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M406.304 366c0-26.632 41.73-59.794 41.73-112.55 0-52.755-60.333-81.901-60.333-147.218 0-65.3158 30.164-82.6176 30.164-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M417.998 366c0-26.632 41.496-59.794 41.496-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 30-82.6176 30-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M429.562 366c0-26.632 41.729-59.794 41.729-112.55 0-52.755-60.333-81.901-60.333-147.218 0-65.3158 30.169-82.6176 30.169-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M441.253 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M452.713 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M464.507 366c0-26.632 41.501-59.794 41.501-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.996-82.6176 29.996-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M475.984 366c0-26.632 41.484-59.794 41.484-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 30.005-82.6176 30.005-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M487.649 366c0-26.632 41.279-59.794 41.279-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.821-82.6176 29.821-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M499.125 366c0-26.632 41.263-59.794 41.263-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.832-82.6176 29.832-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M510.687 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M522.38 366c0-26.632 41.265-59.794 41.265-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.83-82.6176 29.83-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M533.944 366c0-26.632 41.498-59.794 41.498-112.55 0-52.755-59.996-81.901-59.996-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M545.639 366c0-26.632 41.263-59.794 41.263-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.828-82.6176 29.828-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M557.099 366c0-26.632 41.263-59.794 41.263-112.55 0-52.755-59.659-81.901-59.659-147.218 0-65.3158 29.828-82.6176 29.828-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M568.896 366c0-26.632 41.264-59.794 41.264-112.55 0-52.755-59.66-81.901-59.66-147.218 0-65.3158 29.832-82.6176 29.832-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M580.356 366c0-26.632 41.264-59.794 41.264-112.55 0-52.755-59.66-81.901-59.66-147.218 0-65.3158 29.828-82.6176 29.828-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M591.918 366c0-26.632 41.499-59.794 41.499-112.55 0-52.755-59.997-81.901-59.997-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M603.378 366c0-26.632 41.499-59.794 41.499-112.55 0-52.755-59.997-81.901-59.997-147.218 0-65.3158 29.998-82.6176 29.998-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M614.939 366c0-26.632 41.735-59.794 41.735-112.55 0-52.755-60.334-81.901-60.334-147.218 0-65.3158 30.165-82.6176 30.165-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M626.637 366c0-26.632 41.497-59.794 41.497-112.55 0-52.755-59.997-81.901-59.997-147.218 0-65.3158 29.996-82.6176 29.996-106.232' opacity='.14'/%3E%3Cpath stroke='%23333535' stroke-miterlimit='10' stroke-width='1' d='M638.201 366c0-26.632 41.73-59.794 41.73-112.55 0-52.755-60.334-81.901-60.334-147.218 0-65.3158 30.169-82.6176 30.169-106.232' opacity='.14'/%3E%3C/svg%3E")
  }
    }

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] ul{
      padding:0 !important;
    }

@media (min-width: 1024px){

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li:first-of-type{
      font-size:var(--fs-4xl) !important
  }
    }

@media (min-width: 768px){

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li:first-of-type{
      font-size:var(--fs-2xl);
      font-weight:var(--fw-medium);
      padding-bottom:2rem
  }

      :host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li:first-of-type a::before{
        content:'';
        background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 18 16'%3E%3Cpath fill='%231C4BB8' fill-rule='evenodd' d='M9.87109 0.5L17.6136 8.20511L17.6135 8.20521L17.627 8.21861L9.88446 15.9237L7.3916 13.4429L10.8787 9.97269H0V6.46428H10.8786L7.37824 2.98082L9.87109 0.5Z' clip-rule='evenodd'/%3E%3C/svg%3E");
        background-position:center;
        background-repeat:no-repeat;
        display:flex;
        width:1.25rem;
        height:1.25rem;
        position:absolute;
        margin-left:1rem;
        left:100%;
        bottom:25%;
        top:30%;
      }
    }

@media (max-width: 767px){

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li:last-of-type{
      padding-bottom:0
  }
    }

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li{
    color:var(--brand-neutral-gray-800);
    font-size:var(--fs-sm);
    font-weight:var(--fw-medium);
    padding-bottom:2rem;
  }

@media (min-width: 1024px){

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li{
      font-size:var(--fs-base)
  }
    }

@media (min-width: 768px){

:host([trigger-variant='dropdown-nav']) ul[cloned-slot-name='dropdown'] li{
      font-weight:var(--fw-bold);
      padding-bottom:1rem
  }
    }

.control-spacer{
  position:relative;
}
`;